(function () {
  const setTemporaryFocus = (element) => {
    if (!element) return false;
    const hadTabindex = element.hasAttribute('tabindex');
    const previousTabindex = element.getAttribute('tabindex');
    element.setAttribute('tabindex', '-1');
    try {
      element.focus({ preventScroll: false });
    } catch (err) {
      element.focus();
    }
    const removeTabIndex = () => {
      if (hadTabindex && previousTabindex !== null) {
        element.setAttribute('tabindex', previousTabindex);
      } else {
        element.removeAttribute('tabindex');
      }
      element.removeEventListener('blur', removeTabIndex);
    };
    element.addEventListener('blur', removeTabIndex);
    return true;
  };

  window.focusCartItemTitle = function (itemCount) {
    const firstTitle = document.querySelector('.js-cart-item-title');
    if (firstTitle) {
      return setTemporaryFocus(firstTitle);
    }

    if (typeof itemCount === 'number' && itemCount === 0) {
      const emptyHeading = document.querySelector('.cart__title, main h1');
      if (emptyHeading) {
        return setTemporaryFocus(emptyHeading);
      }
    }

    const fallbackHeading = document.querySelector('.cart__title, main h1');
    if (fallbackHeading) {
      return setTemporaryFocus(fallbackHeading);
    }

    return false;
  };
})();

    const skipLink = document.querySelector('.skip-link');
    const mainContent = document.getElementById('main-content');
    if (skipLink && mainContent) {
      const focusMain = () => {
        mainContent.setAttribute('tabindex', '-1');
        mainContent.focus({ preventScroll: false });
        const removeTabIndex = () => {
          mainContent.removeAttribute('tabindex');
          mainContent.removeEventListener('blur', removeTabIndex);
        };
        mainContent.addEventListener('blur', removeTabIndex);
      };

      skipLink.addEventListener('click', function (event) {
        event.preventDefault();
        focusMain();
      });

      if (window.location.pathname === '/cart') {
        let shouldFocusCartMain = false;
        try {
          shouldFocusCartMain = sessionStorage.getItem('header-cart-return-focus') === 'true';
        } catch (err) {
          shouldFocusCartMain = false;
        }
        if (shouldFocusCartMain) {
          const didFocusTitle = window.focusCartItemTitle && window.focusCartItemTitle();
          if (!didFocusTitle) {
            focusMain();
          }
          try {
            sessionStorage.removeItem('header-cart-return-focus');
          } catch (err) {
            // ignore
          }
        }
      }
    }
// Accordion toggle function - handles both click and keyboard
function toggleAccordion(button) {
  const $button = jQuery(button);
  const panelId = $button.attr('aria-controls');
  const $panel = panelId ? jQuery(`#${panelId}`) : $button.next('.accordion-body');
  const isExpanded = $button.attr('aria-expanded') === 'true';
  const newState = !isExpanded;

  $button.attr('aria-expanded', newState);
  $button.toggleClass('open', newState);

  if ($panel.length) {
    $panel.attr('aria-hidden', (!newState).toString());

    // Announce state change to screen readers
    const buttonText = $button.find('div:first').text().trim() || 'Filter option';
    const announcement = newState ? buttonText + ' expanded' : buttonText + ' collapsed';
    
    // Create or update aria-live region
    let $liveRegion = jQuery('#filter-accordion-announcements');
    if (!$liveRegion.length) {
      $liveRegion = jQuery('<div id="filter-accordion-announcements" class="sr-only" aria-live="polite" aria-atomic="true"></div>');
      jQuery('body').append($liveRegion);
    }
    $liveRegion.text(announcement);

    if (newState) {
      setTimeout(function () {
        // Ensure wrapper divs are not focusable before finding focus target
        ensureFilterLinksAreFocusable();
        
        // Prioritize filter links/options (the actual selectable items)
        // Look for filter option links first - these are the clickable filter values
        // Make sure we get the actual <a> tag, not wrapper divs
        let $focusTarget = $panel.find('a[href]').filter(':visible').first();
        
        // Ensure wrapper divs don't interfere - explicitly set tabindex="-1" on them
        $panel.find('.block, .type-item, .size-item, .color-item').not('a').attr('tabindex', '-1');
        
        // If no links, try other interactive elements
        if (!$focusTarget.length) {
          $focusTarget = $panel.find('button:not(.js-trigger), input, select, textarea').filter(':visible').first();
        }
        
        // If still nothing, try list items or other semantic elements
        if (!$focusTarget.length) {
          $focusTarget = $panel.find('li, [data-accordion-focus="true"]').filter(':visible').first();
        }
        
        // Last resort: the panel itself
        if (!$focusTarget.length) {
          $focusTarget = $panel;
        }

        // Only add tabindex if it's not already a naturally focusable element
        const isNaturallyFocusable = $focusTarget.is('a, button, input, select, textarea, [tabindex]');
        if (!isNaturallyFocusable) {
          $focusTarget.attr('tabindex', '-1').attr('data-temp-tabindex', 'true');
        }

        $focusTarget.focus({ preventScroll: false });

        $focusTarget.one('blur', function () {
          if (jQuery(this).attr('data-temp-tabindex') === 'true') {
            jQuery(this).removeAttr('tabindex').removeAttr('data-temp-tabindex');
          }
        });
      }, 50);
    } else {
      // When closing, don't move focus - let it stay where it is or return naturally
      // This allows multi-select without losing context
      $panel.removeAttr('tabindex');
      $panel.find('[data-temp-tabindex="true"]').removeAttr('tabindex data-temp-tabindex');
    }
  }
}

// Click handler for accordions - prevent clicks on filter links from toggling
jQuery('.js-trigger').on('click', function (e) {
  // Don't toggle if clicking on a filter link inside the accordion
  const $clicked = jQuery(e.target);
  if ($clicked.closest('a[href]').length || $clicked.is('a[href]')) {
    return; // Let the link handle its own click
  }
  toggleAccordion(this);
});

// Keyboard handler for accordions (Enter and Space)
jQuery('.js-trigger').on('keydown', function (e) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    toggleAccordion(this);
  }
});

// Helper function to handle filter link activation (used by both click and keyboard)
function handleFilterLinkActivation(linkElement, event) {
  const $link = jQuery(linkElement);
  const $panel = $link.closest('.accordion-body');
  const $button = $panel.siblings('.js-trigger').first();
  
  // Keep accordion open
  if ($button.length && $panel.length) {
    $button.attr('aria-expanded', 'true');
    $panel.attr('aria-hidden', 'false');
    $button.addClass('open');
  }
  
  // Always prevent navigation and handle via AJAX to enable multi-select
  // Check if this is a filter link (in filter section)
  const isFilterLink = $link.closest('[data-filter-flyout="true"], [data-filter-panel="true"]').length > 0;
  
  // CRITICAL: Check if this is a type-item, size-item, or color-item link
  // These are handled by our custom multi-select handler in filter.liquid
  // Skip this handler to prevent conflicts
  const isCustomFilterLink = $link.closest('.type-item, .size-item, .color-item').length > 0;
  
  if (isFilterLink && !isCustomFilterLink) {
    // Only handle non-custom filter links (e.g., active filter remove buttons)
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // Get the filter URL
    const filterUrl = $link.attr('href');
    if (filterUrl) {
      // Always use AJAX to update, regardless of flyout state
      const filterFlyout = document.querySelector('.filter-flyout');
      updateCollectionFilters(filterUrl, filterFlyout);
    }
    
    return false;
  }
  
  // If it's a custom filter link (type-item, size-item, color-item), skip this handler
  // The handler in filter.liquid will handle it with multi-select support
  if (isCustomFilterLink) {
    return false; // Don't handle - let filter.liquid handler take over
  }
}

// Prevent filter links from closing accordions - ensure accordions stay open for multi-select
// Also intercept clicks to prevent flyout from closing and enable multi-select
jQuery(document).on('click', '.accordion-body a[href]', function(e) {
  handleFilterLinkActivation(this, e);
});

// Add keyboard support for filter links (Spacebar and Enter)
jQuery(document).on('keydown', '.accordion-body a[href]', function(e) {
  const $link = jQuery(this);
  const isFilterLink = $link.closest('[data-filter-flyout="true"], [data-filter-panel="true"]').length > 0;
  
  if (isFilterLink) {
    // Handle Spacebar (Enter works by default on links, but we'll handle it too for consistency)
    if (e.key === ' ' || e.key === 'Space' || e.key === 'Spacebar' || e.keyCode === 32) {
      e.preventDefault();
      e.stopPropagation();
      handleFilterLinkActivation(this, e);
      return false;
    }
    // Handle Enter (though it should work by default, we'll ensure it uses AJAX)
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      handleFilterLinkActivation(this, e);
      return false;
    }
  }
});

// Attach handlers for active filter remove buttons and clear all link
// This enables multi-select and individual filter removal
function attachActiveFilterHandlers() {
  // Handle individual filter remove buttons (X button)
  jQuery('.js-active-filter-remove-btn').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Find the remove link in the same group and use its href
    const $button = jQuery(this);
    const $group = $button.closest('.active-filter-tag');
    const $removeLink = $group.find('.js-active-filter-remove');
    
    if ($removeLink.length) {
      const removeUrl = $removeLink.attr('href');
      if (removeUrl) {
        // Always use AJAX, regardless of flyout state
        const filterFlyout = document.querySelector('.filter-flyout');
        updateCollectionFilters(removeUrl, filterFlyout);
      }
    }
    
    return false;
  });
  
  // Handle active filter remove links (clicking the filter name)
  jQuery('.js-active-filter-remove').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const removeUrl = jQuery(this).attr('href');
    if (removeUrl) {
      // Always use AJAX, regardless of flyout state
      const filterFlyout = document.querySelector('.filter-flyout');
      updateCollectionFilters(removeUrl, filterFlyout);
    }
    
    return false;
  });
  
  // Handle clear all filters link
  jQuery('.js-clear-all-filters').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const clearUrl = jQuery(this).attr('href');
    if (clearUrl) {
      // Always use AJAX, regardless of flyout state
      const filterFlyout = document.querySelector('.filter-flyout');
      updateCollectionFilters(clearUrl, filterFlyout);
    }
    
    return false;
  });
}

// Ensure filter wrapper divs are not focusable - only links should be
function ensureFilterLinksAreFocusable() {
  // Remove tabindex from wrapper divs and ensure they can't receive focus
  jQuery('.accordion-body .block, .accordion-body .type-item, .accordion-body .size-item, .accordion-body .color-item').each(function() {
    const $wrapper = jQuery(this);
    // Only process if it's not already a link
    if (!$wrapper.is('a')) {
      $wrapper.attr('tabindex', '-1');
      // Ensure any child elements that aren't links are also not focusable
      $wrapper.children().not('a').each(function() {
        const $child = jQuery(this);
        if (!$child.is('a, button, input, select, textarea')) {
          $child.attr('tabindex', '-1');
        }
      });
    }
  });
  
  // Ensure all filter links are focusable
  jQuery('.accordion-body a[href]').each(function() {
    const $link = jQuery(this);
    // Remove any negative tabindex that might prevent focus
    if ($link.attr('tabindex') === '-1') {
      $link.removeAttr('tabindex');
    }
    // Ensure link is in tab order
    if (!$link.attr('tabindex') || $link.attr('tabindex') === '-1') {
      $link.removeAttr('tabindex');
    }
  });
}

// Initialize active filter handlers on page load
jQuery(document).ready(function() {
  attachActiveFilterHandlers();
  ensureFilterLinksAreFocusable();
  
  // Re-run after any DOM updates (like AJAX filter updates)
  const observer = new MutationObserver(function(mutations) {
    ensureFilterLinksAreFocusable();
  });
  
  // Observe filter containers for changes
  const filterContainers = document.querySelectorAll('[data-filter-flyout="true"], [data-filter-panel="true"]');
  filterContainers.forEach(function(container) {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  });
});

// Update collection filters via AJAX while keeping flyout open
function updateCollectionFilters(url, flyout) {
  // Show loading state
  const productsGrid = document.querySelector('.js-products');
  if (productsGrid) {
    productsGrid.style.opacity = '0.5';
    productsGrid.style.pointerEvents = 'none';
  }
  
  // Fetch the new collection page
  fetch(url)
    .then(function(response) {
      return response.text();
    })
    .then(function(html) {
      // Parse the response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Update the products grid
      const newProductsGrid = doc.querySelector('.js-products');
      const newActiveTags = doc.querySelector('.active-tags');
      const newPagination = doc.querySelector('.pagination');
      
      if (productsGrid && newProductsGrid) {
        productsGrid.innerHTML = newProductsGrid.innerHTML;
      }
      
      // Update active filters/tags display
      if (newActiveTags) {
        const currentActiveTags = document.querySelector('.active-tags');
        if (currentActiveTags) {
          currentActiveTags.innerHTML = newActiveTags.innerHTML;
          // Re-attach event handlers to new active filter links
          attachActiveFilterHandlers();
        } else {
          // If active tags container doesn't exist, find where to insert it
          const productsHeader = document.querySelector('.products-header');
          if (productsHeader) {
            productsHeader.insertBefore(newActiveTags, productsHeader.firstChild);
            attachActiveFilterHandlers();
          }
        }
      }
      
      if (newPagination) {
        const currentPagination = document.querySelector('.pagination');
        if (currentPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        }
      }
      
      // Update URL without page reload
      window.history.pushState({}, '', url);
      
      // Update filter links in the flyout to reflect new state
      // Always update filter content, even if flyout is closed, so filters stay in sync
      const filterFlyout = document.querySelector('.filter-flyout');
      const currentFilterContent = filterFlyout ? filterFlyout.querySelector('[data-filter-flyout="true"]') : null;
      const newFilterSection = doc.querySelector('#filter-section-container');
      
      if (currentFilterContent && newFilterSection && newFilterSection.children.length > 0) {
        // Get the filter section element from the new document
        const newFilterElement = newFilterSection.children[0];
        if (newFilterElement) {
          // Remember which accordions were open before update
          const wasOpen = {};
          if (filterFlyout) {
            const openAccordions = filterFlyout.querySelectorAll('.accordion.open, .accordion[aria-expanded="true"]');
            openAccordions.forEach(function(accordion) {
              const button = accordion;
              const panelId = button.getAttribute('aria-controls');
              if (panelId) {
                wasOpen[panelId] = true;
              }
            });
          }
          
          // Clear current content and clone the new filter element
          currentFilterContent.innerHTML = '';
          const clonedFilter = newFilterElement.cloneNode(true);
          currentFilterContent.appendChild(clonedFilter);
          
          // Restore open accordions if flyout was open
          if (filterFlyout && Object.keys(wasOpen).length > 0) {
            Object.keys(wasOpen).forEach(function(panelId) {
              const panel = currentFilterContent.querySelector('#' + panelId);
              const button = currentFilterContent.querySelector('[aria-controls="' + panelId + '"]');
              if (panel && button) {
                button.setAttribute('aria-expanded', 'true');
                button.classList.add('open');
                panel.setAttribute('aria-hidden', 'false');
                // Show the panel (accordion-body might be hidden by default)
                if (panel.classList.contains('accordion-body')) {
                  panel.style.display = 'block';
                }
              }
            });
          }
        }
      }
      
      // Also update inline filter panel if it exists
      const inlineFilterPanel = document.querySelector('[data-filter-panel="true"]');
      if (inlineFilterPanel && newFilterSection && newFilterSection.children.length > 0) {
        const newFilterElement = newFilterSection.children[0];
        if (newFilterElement) {
          inlineFilterPanel.innerHTML = '';
          const clonedFilter = newFilterElement.cloneNode(true);
          inlineFilterPanel.appendChild(clonedFilter);
        }
      }
      
      // Restore opacity
      if (productsGrid) {
        productsGrid.style.opacity = '1';
        productsGrid.style.pointerEvents = 'auto';
      }
      
      // Re-initialize accordion handlers for new content
      jQuery('.js-trigger').off('click').on('click', function(e) {
        const $clicked = jQuery(e.target);
        if ($clicked.closest('a[href]').length || $clicked.is('a[href]')) {
          return;
        }
        toggleAccordion(this);
      });
      
      // Ensure filter links are focusable after AJAX update
      ensureFilterLinksAreFocusable();
      
      // Re-attach filter link click handlers (using helper function)
      // Note: Since we use event delegation with jQuery(document).on(), 
      // handlers automatically work on dynamically added content, but we re-attach
      // here for explicit clarity and to ensure they work immediately
      jQuery('.accordion-body a[href]').off('click').on('click', function(e) {
        handleFilterLinkActivation(this, e);
      });
      
      // Re-attach keyboard handlers for filter links
      jQuery('.accordion-body a[href]').off('keydown').on('keydown', function(e) {
        const $link = jQuery(this);
        const isFilterLink = $link.closest('[data-filter-flyout="true"], [data-filter-panel="true"]').length > 0;
        
        if (isFilterLink) {
          // Handle Spacebar
          if (e.key === ' ' || e.key === 'Space' || e.key === 'Spacebar' || e.keyCode === 32) {
            e.preventDefault();
            e.stopPropagation();
            handleFilterLinkActivation(this, e);
            return false;
          }
          // Handle Enter
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
            handleFilterLinkActivation(this, e);
            return false;
          }
        }
      });
      
      // Re-attach active filter handlers
      attachActiveFilterHandlers();
    })
    .catch(function(error) {
      console.error('Error updating filters:', error);
      // Fallback to full page navigation
      window.location.href = url;
    });
}
  
  // jQuery('.has-megamenu').addEventListener('keypress', function () {
    
  
  
  // })
  
  (function () {
    const focusableSelector =
      'a[href], area[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function initMegaMenu() {
      const menuItems = Array.from(document.querySelectorAll('[data-megamenu-item]'));
      if (!menuItems.length) return;

      const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
      let openItem = null;
      let lastFocusBeforeOpen = null;

      const setTabbable = (panel, enabled) => {
        const subLinks = Array.from(panel.querySelectorAll(focusableSelector));
        subLinks.forEach((link) => {
          if (enabled) {
            link.removeAttribute('tabindex');
          } else {
            link.setAttribute('tabindex', '-1');
          }
        });
      };

      const closeItem = (item) => {
        const trigger = item.querySelector('[data-megamenu-trigger]');
        const panelId = trigger ? trigger.getAttribute('aria-controls') : null;
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!trigger || !panel) return;

        item.classList.remove('is-open');
        item.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.classList.add('hidden');
        setTabbable(panel, false);
      };

      const openItemFn = (item, focusFirstEl) => {
        if (!isDesktop()) return;
        if (openItem && openItem !== item) {
          closeItem(openItem);
        }

        const trigger = item.querySelector('[data-megamenu-trigger]');
        const panelId = trigger ? trigger.getAttribute('aria-controls') : null;
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!trigger || !panel) return;

        item.classList.add('is-open');
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.remove('hidden');
        openItem = item;
        setTabbable(panel, focusFirstEl);

        if (focusFirstEl) {
          lastFocusBeforeOpen = trigger;
          const focusable = Array.from(panel.querySelectorAll(focusableSelector)).filter((el) =>
            !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
          );
          const target = focusable[0] || panel;
          target.focus();
        }
      };

      const isPointerInside = (item, target) => {
        if (!target) return false;
        const panel = item.querySelector('[data-megamenu-panel]');
        return item.contains(target) || (panel && panel.contains(target));
      };

      let hoverIntentTimer = null;
      let lastPointerEvent = null;

      const pointerIsWithinItem = (item, targetOverride) => {
        if (!item) return false;
        const target = targetOverride || (lastPointerEvent ? document.elementFromPoint(lastPointerEvent.clientX, lastPointerEvent.clientY) : null);
        if (!target) return false;
        return isPointerInside(item, target);
      };

      const handlePointerEnter = (item) => {
        if (!isDesktop()) return;
        if (hoverIntentTimer) {
          clearTimeout(hoverIntentTimer);
          hoverIntentTimer = null;
        }
        openItemFn(item, false);
      };

      const handlePointerLeave = (item, event) => {
        if (!isDesktop()) return;
        const relatedTarget = event ? event.relatedTarget : null;
        if (relatedTarget && isPointerInside(item, relatedTarget)) {
          return;
        }

        if (hoverIntentTimer) {
          clearTimeout(hoverIntentTimer);
        }

        hoverIntentTimer = setTimeout(() => {
          if (pointerIsWithinItem(item)) {
            return;
          }
          closeItem(item);
          if (openItem === item) {
            openItem = null;
          }
        }, 320);
      };

      const handleTriggerKeydown = (event, item) => {
        const trigger = event.currentTarget;
        switch (event.key) {
          case 'ArrowDown':
          case 'Down':
            event.preventDefault();
            openItemFn(item, true);
            break;
          case 'Enter':
          case ' ':
          case 'Space':
          case 'Spacebar':
            if (isDesktop()) {
              event.preventDefault();
              const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
              if (isExpanded) {
                closeItem(item);
                openItem = null;
              } else {
                openItemFn(item, true);
              }
            }
            break;
          case 'Escape':
            event.preventDefault();
            closeItem(item);
            trigger.focus();
            if (openItem === item) {
              openItem = null;
            }
            break;
          default:
            break;
        }
      };

      const handlePanelKeydown = (event, item, trigger) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeItem(item);
          trigger.focus();
          if (openItem === item) {
            openItem = null;
          }
        }
      };

      menuItems.forEach((item) => {
        const trigger = item.querySelector('[data-megamenu-trigger]');
        if (!trigger) return;
        const panelId = trigger.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        trigger.addEventListener('mouseenter', () => handlePointerEnter(item));
        trigger.addEventListener('mouseleave', (event) => handlePointerLeave(item, event));
        trigger.addEventListener('focus', () => {
          if (openItem && openItem !== item) {
            closeItem(openItem);
            openItem = null;
          }
          setTabbable(panel, false);
        });

        trigger.addEventListener('click', (event) => {
          if (!isDesktop()) {
            return;
          }
          const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
          const isKeyboardEvent = event.detail === 0;
          if (!isExpanded) {
            event.preventDefault();
            openItemFn(item, false);
          } else if (isKeyboardEvent) {
            event.preventDefault();
            return;
          }
        });

        trigger.addEventListener('keydown', (event) => handleTriggerKeydown(event, item));
        trigger.addEventListener('blur', (event) => {
          const nextFocus = event.relatedTarget;
          if (!item.contains(nextFocus)) {
            closeItem(item);
            if (openItem === item) {
              openItem = null;
            }
          }
        });

        panel.addEventListener('mouseenter', () => handlePointerEnter(item));
        panel.addEventListener('mouseleave', (event) => handlePointerLeave(item, event));
        panel.addEventListener('keydown', (event) => handlePanelKeydown(event, item, trigger));
        panel.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) {
            closeItem(item);
            if (openItem === item) {
              openItem = null;
            }
          }
        });
      });
      document.addEventListener('mousemove', () => {
        if (hoverIntentTimer && pointerIsWithinItem(openItem)) {
          clearTimeout(hoverIntentTimer);
          hoverIntentTimer = null;
        }
      });

      document.addEventListener('pointermove', (event) => {
        lastPointerEvent = event;
        if (hoverIntentTimer && pointerIsWithinItem(openItem, event.target)) {
          clearTimeout(hoverIntentTimer);
          hoverIntentTimer = null;
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (!openItem) return;
        closeItem(openItem);
        if (lastFocusBeforeOpen) {
          lastFocusBeforeOpen.focus();
        }
        openItem = null;
      });

      document.addEventListener('click', (event) => {
        if (!openItem) {
          return;
        }
        const panel = openItem.querySelector('[data-megamenu-panel]');
        if (isPointerInside(openItem, event.target)) {
          return;
        }
        closeItem(openItem);
        openItem = null;
      });

      window.addEventListener('resize', () => {
        if (!isDesktop() && openItem) {
          closeItem(openItem);
          openItem = null;
        }
      });
    }

    function initHeaderSearchPromo() {
      const searchInputs = Array.from(document.querySelectorAll('[data-header-search-input]'));
      if (!searchInputs.length) {
        return;
      }

      searchInputs.forEach((searchInput) => {
        const promoMessage = searchInput.getAttribute('data-promo-message');
        const hasPromo = typeof promoMessage === 'string' && promoMessage.trim() !== '';

        const isPromoActive = () => searchInput.getAttribute('data-promo-active') === 'true';

        const setPromoState = (isActive) => {
          if (isActive) {
            searchInput.setAttribute('data-promo-active', 'true');
          } else {
            searchInput.removeAttribute('data-promo-active');
          }
        };

        const clearPromo = () => {
          if (!hasPromo) {
            return;
          }
          if (searchInput.value === promoMessage || isPromoActive()) {
            searchInput.value = '';
            setPromoState(false);
          }
        };

        const restorePromo = () => {
          if (!hasPromo) {
            return;
          }
          if (searchInput.value.trim() === '') {
            searchInput.value = promoMessage;
            setPromoState(true);
          }
        };

        if (hasPromo) {
          if (searchInput.value.trim() === '') {
            searchInput.value = promoMessage;
            setPromoState(true);
          } else if (searchInput.value === promoMessage) {
            setPromoState(true);
          } else {
            setPromoState(false);
          }
        } else {
          setPromoState(false);
        }

        searchInput.addEventListener('focus', clearPromo);
        searchInput.addEventListener('blur', restorePromo);
        searchInput.addEventListener('input', () => {
          if (!hasPromo) {
            return;
          }
          if (searchInput.value === promoMessage) {
            setPromoState(true);
          } else {
            setPromoState(false);
          }
        });

        if (searchInput.form) {
          searchInput.form.addEventListener('submit', clearPromo);
        }
      });
    }

    function initHeroBleedExperience() {
      const header = document.querySelector('header[data-site-header]');
      if (!header) {
        return;
      }

      const logo = header.querySelector('[data-header-logo]');
      const defaultLogo = logo ? logo.getAttribute('data-logo-default') : null;
      const bleedLogo = logo ? logo.getAttribute('data-logo-bleed') : null;

      const swapLogo = (useBleed) => {
        if (!logo) return;
        const nextSrc = useBleed ? bleedLogo : defaultLogo;
        if (nextSrc && logo.getAttribute('src') !== nextSrc) {
          logo.setAttribute('src', nextSrc);
        }
      };

      const heroRoot = document.querySelector('[data-hero-bleed-root]');
      if (!heroRoot) {
        try {
          sessionStorage.removeItem(KEYBOARD_STORAGE_KEY);
        } catch (err) {
          // ignore
        }
        document.body.classList.remove('hero-bleed-enabled', 'hero-bleed-mode-transparent', 'hero-bleed-mode-solid');
        swapLogo(false);
        return;
      }

      document.body.classList.add('hero-bleed-enabled');

      const KEYBOARD_STORAGE_KEY = 'hero-bleed-keyboard-lock';
      let keyboardLocked = false;
      let keydownAttached = true;
      try {
        keyboardLocked = sessionStorage.getItem(KEYBOARD_STORAGE_KEY) === 'true';
      } catch (err) {
        keyboardLocked = false;
      }

      const isHighContrastActive = () => {
        const mode = document.documentElement.getAttribute('data-contrast-mode');
        return mode && mode !== 'off';
      };

      let currentMode = null;
      const setMode = (mode) => {
        if (currentMode === mode) {
          return;
        }
        currentMode = mode;
        const isTransparent = mode === 'transparent';
        document.body.classList.toggle('hero-bleed-mode-transparent', isTransparent);
        document.body.classList.toggle('hero-bleed-mode-solid', mode === 'solid');
        swapLogo(isTransparent);
      };

      const updateMode = (pointerInsideHeader = false) => {
        if (isHighContrastActive() || keyboardLocked) {
          setMode('solid');
          return;
        }
        if (pointerInsideHeader) {
          setMode('solid');
        } else {
          setMode('transparent');
        }
      };

      let pointerInsideHeader = false;
      updateMode(pointerInsideHeader);

      const handlePointerEnter = () => {
        pointerInsideHeader = true;
        updateMode(pointerInsideHeader);
      };

      const handlePointerLeave = () => {
        pointerInsideHeader = false;
        if (keyboardLocked && !isHighContrastActive()) {
          keyboardLocked = false;
          try {
            sessionStorage.removeItem(KEYBOARD_STORAGE_KEY);
          } catch (err) {
            // ignore storage errors
          }
          if (!keydownAttached) {
            document.addEventListener('keydown', handleKeydown);
            keydownAttached = true;
          }
        }
        updateMode(pointerInsideHeader);
      };

      const handleDocumentPointerDown = (event) => {
        pointerInsideHeader = header.contains(event.target);
        updateMode(pointerInsideHeader);
      };

      const handleKeydown = (event) => {
        if (keyboardLocked) return;
        if (event.key === 'Tab') {
          keyboardLocked = true;
          try {
            sessionStorage.setItem(KEYBOARD_STORAGE_KEY, 'true');
          } catch (err) {
            // ignore storage errors
          }
          updateMode(pointerInsideHeader);
          if (keydownAttached) {
            document.removeEventListener('keydown', handleKeydown);
            keydownAttached = false;
          }
        }
      };

      const contrastObserver = new MutationObserver(() => {
        updateMode(pointerInsideHeader);
      });
      contrastObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-contrast-mode'] });

      header.addEventListener('pointerenter', handlePointerEnter);
      header.addEventListener('pointerleave', handlePointerLeave);
      header.addEventListener('pointerdown', handlePointerEnter);
      document.addEventListener('pointerdown', handleDocumentPointerDown, { passive: true });
      document.addEventListener('keydown', handleKeydown);

      window.addEventListener('pageshow', () => {
        keyboardLocked = false;
        document.body.classList.remove('hero-bleed-mode-solid');
        document.body.classList.add('hero-bleed-mode-transparent');
        try {
          sessionStorage.removeItem(KEYBOARD_STORAGE_KEY);
        } catch (err) {
          // ignore storage errors
        }
        if (!keydownAttached) {
          document.addEventListener('keydown', handleKeydown);
          keydownAttached = true;
        }
        updateMode(false);
      });
    }

    function initHeaderAccessibility() {
      initMegaMenu();
      initHeaderSearchPromo();
      initHeroBleedExperience();
      const spaceClickTargets = Array.from(document.querySelectorAll('[data-activate-on-space]'));
      spaceClickTargets.forEach((el) => {
        el.addEventListener('keydown', (event) => {
          if (event.key === ' ' || event.key === 'Space' || event.key === 'Spacebar' || event.keyCode === 32) {
            event.preventDefault();
            el.click();
          }
        });
      });

      if (window.location.pathname === '/cart') {
        setTimeout(() => {
          if (typeof window.focusCartItemTitle === 'function') {
            window.focusCartItemTitle();
          }
        }, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeaderAccessibility);
    } else {
      initHeaderAccessibility();
    }
  })();